<template>
    <div class="wrap">
        <div class="footer">
            <div class="main">
                <!-- 顶部导航链接 -->
                <el-row class="footer-nav">
                    <el-col :span="2">
                        <router-link to="/aboutUs1" class="nav-link">走进我们</router-link>
                    </el-col>
                    <el-col :span="2">
                        <router-link to="/aboutUs1" class="nav-link">联系我们</router-link>
                    </el-col>
                    <el-col :span="2">
                        <router-link to="/aboutUs1" class="nav-link">加入我们</router-link>
                    </el-col>
                    <el-col :span="2">
                        <router-link to="/aboutUs1" class="nav-link">隐私声明</router-link>
                    </el-col>
                    <el-col :span="2">
                        <router-link to="/aboutUs1" class="nav-link">友情链接</router-link>
                    </el-col>
                    <el-col :span="12" class="hotline">
                        热线：028-62128912
                    </el-col>
                </el-row>

                <!-- 主要内容区域 -->
                <el-row class="footer-content">
                    <el-col :span="6" class="logo-section">
                        <img src="/static/img/logo.png" class="logo" alt="城市好房" />
                    </el-col>
                    
                    <el-col :span="10" class="company-info">
                        <div class="info-item">©2019-2025 四川百成恒泰房地产营销策划有限公司</div>
                        <div class="info-item">地址：四川省成都市锦江区东大街芷泉段229号1栋2单元6层608号</div>
                        <div class="info-item">开发者：四川百成恒泰房地产营销策划有限公司</div>
                        <div class="info-item">
                            <a href="https://beian.miit.gov.cn" target="_blank" class="beian-link">蜀ICP备2025160443号-1</a>
                        </div>
                        <div class="info-item">版权所有 | 四川百成恒泰房地产营销策划有限公司</div>
                    </el-col>
                    
                    <el-col :span="8" class="qr-section">
                        <!-- <div class="qr-container">
                            <div class="qr-item">
                                <img src="/static/img/rcord.png" class="qr-code" alt="公众号" />
                                <p class="qr-label">关注公众号</p>
                            </div>
                            <div class="qr-item">
                                <img src="/static/img/xiaochengxu.jpg" class="qr-code" alt="小程序" />
                                <p class="qr-label">小程序</p>
                            </div>
                        </div> -->
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    created() { },
    mounted() { },
    methods: {}
};
</script>

<style scoped lang="scss">
.wrap {
    margin-top: 60px;
}

.footer {
    width: 100%;
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
    border-top: 3px solid #e74c3c;
    color: #ecf0f1;
    padding: 40px 0 20px;
}

.main {
    width: 75rem;
    margin: 0 auto;
    max-width: 1200px;
}

.footer-nav {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 20px;
    margin-bottom: 30px;
    align-items: center;
    
    .nav-link {
        color: #bdc3c7;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
        transition: all 0.3s ease;
        
        &:hover {
            color: #e74c3c;
            text-decoration: none;
        }
    }
    
    .hotline {
        text-align: right;
        color: #e74c3c;
        font-size: 18px;
        font-weight: 600;
    }
}

.footer-content {
    align-items: flex-start;
    
    .logo-section {
        text-align: center;
        
        .logo {
            width: 140px;
            height: auto;
            max-height: 60px;
            object-fit: contain;
        }
    }
    
    .company-info {
        padding-left: 20px;
        
        .info-item {
            color: #bdc3c7;
            font-size: 13px;
            line-height: 1.6;
            margin-bottom: 8px;
            
            &:first-child {
                font-weight: 600;
                color: #ecf0f1;
                margin-bottom: 15px;
            }
        }
        
        .beian-link {
            color: #bdc3c7;
            text-decoration: none;
            transition: color 0.3s ease;
            
            &:hover {
                color: #e74c3c;
                text-decoration: underline;
            }
        }
    }
    
    .qr-section {
        .qr-container {
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 100%;
        }
        
        .qr-item {
            text-align: center;
            
            .qr-code {
                width: 80px;
                height: 80px;
                border-radius: 8px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
                transition: transform 0.3s ease;
                
                &:hover {
                    transform: scale(1.05);
                }
            }
            
            .qr-label {
                margin-top: 8px;
                font-size: 12px;
                color: #bdc3c7;
                margin-bottom: 0;
            }
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .main {
        width: 95%;
        padding: 0 10px;
    }
    
    .footer-nav {
        .nav-link {
            font-size: 12px;
        }
        
        .hotline {
            font-size: 16px;
            text-align: center;
            margin-top: 10px;
        }
    }
    
    .footer-content {
        .logo-section, .company-info, .qr-section {
            margin-bottom: 20px;
        }
        
        .qr-container {
            justify-content: center;
            gap: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue